import { auth } from "./firebase";

const BASE = process.env.REACT_APP_DATA_API || "/.netlify/functions/data";

async function authedFetch(url) {
  const user = auth.currentUser;
  if (!user) throw new Error("Not signed in");
  const token = await user.getIdToken();
  const res = await fetch(url, {
    headers: { Authorization: `Bearer ${token}` },
    cache: "no-store",
  });
  if (res.status === 401) throw new Error("Session expired. Please sign in again.");
  if (!res.ok) throw new Error("HTTP " + res.status);
  return res.json();
}

export const fetchManifest = () => authedFetch(BASE);
export const fetchFactionById = (id) => authedFetch(`${BASE}?id=${encodeURIComponent(id)}`);
